import React from 'react';
import {connect} from 'react-redux';

import {gettext} from 'topmeteo/utils/i18n';

import {getProduct} from '../../../../general/selectors';
import {changeIndex} from '../../../actionCreators';

import Base from './Base';

const Label = gettext('Change time');

const Now = props => (
    <Base
        {...props}
        id="now"
        title={Label}
        direction="up"
    />
);

const mapStateToProps = state => {
    const {resolution, columns} = getProduct(state);

    return {
        index: state.index,
        resolution,
        columns,
    };
};

const mapDispatchToProps = dispatch => ({
    onMove: (event, index, {resolution, columns, index: currentIndex}) => {
        const column = Math.floor(index / resolution);
        const {available} = columns[column];

        if (index === currentIndex || available === false) return;

        dispatch(changeIndex(index));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Now);
